/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EmailAuthorizationSimple model module.
 * @module model/EmailAuthorizationSimple
 * @version V1
 */
class EmailAuthorizationSimple {
    /**
     * Constructs a new <code>EmailAuthorizationSimple</code>.
     * @alias module:model/EmailAuthorizationSimple
     */
    constructor() { 
        
        EmailAuthorizationSimple.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EmailAuthorizationSimple</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EmailAuthorizationSimple} obj Optional instance to populate.
     * @return {module:model/EmailAuthorizationSimple} The populated <code>EmailAuthorizationSimple</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EmailAuthorizationSimple();

            if (data.hasOwnProperty('postMarkId')) {
                obj['postMarkId'] = ApiClient.convertToType(data['postMarkId'], 'Number');
            }
            if (data.hasOwnProperty('confirmed')) {
                obj['confirmed'] = ApiClient.convertToType(data['confirmed'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EmailAuthorizationSimple</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EmailAuthorizationSimple</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} postMarkId
 */
EmailAuthorizationSimple.prototype['postMarkId'] = undefined;

/**
 * @member {Boolean} confirmed
 */
EmailAuthorizationSimple.prototype['confirmed'] = undefined;






export default EmailAuthorizationSimple;

